import { useState, useCallback, useEffect } from "react"

import { useLocation } from "react-router-dom"

const useRouteParameterState = <T extends object>(initialState: T) => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const [state, setState] = useState<T>(() => {
    const initialStateFromParams = Object.fromEntries(
      Object.keys(initialState).map((key) => {
        // It converts the string param to number
        if (
          key === "pageNo" ||
          key === "page" ||
          key === "limit" ||
          key === "noOfRecords"
        ) {
          return [
            key,
            Number(searchParams.get(key)) || Number(initialState[key]),
          ]
        }
        return [key, searchParams.get(key) || initialState[key]]
      }),
    )
    return { ...initialState, ...initialStateFromParams }
  })

  const reducer = useCallback((newState: Partial<T>) => {
    setState((prevState) => ({ ...prevState, ...newState }))
  }, [])

  useEffect(() => {
    const queryObj = Object.entries(state).map(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      (e) => [e[0], `${e[1]}`] as [string, string],
    )
    const updatedParams = new URLSearchParams(queryObj)
    window.history.replaceState(
      {},
      "",
      `${location.pathname}?${updatedParams.toString()}`,
    )
  }, [state, location.pathname])

  return { state, reducer }
}

export default useRouteParameterState
